import { t } from "i18next"

export const DocumentDueList = ({ documentsDue = [], debtor = '' }) => {
    return (
        <div>
            <h5 className="fw-bold">
                {
                    debtor ?
                        <>{t('DUE_DOC_OF')} {debtor}</>
                        :
                        t('DUE_DOC_OF_THE_RESOURCE')
                }
            </h5>
            <div
                className="row row-cols-1 gap-2 no-show-scroll"
                style={{ maxHeight: '150px', overflowY: 'scroll' }}
            >
                {
                    documentsDue.map((documentDue, idx) =>
                        <div
                            key={idx}
                            className="col"
                        >
                            <span className="dark-text fs-6"><strong className="blue-text fs-6">{documentDue.document_code}</strong> - {documentDue.document_desc}</span>
                        </div>
                    )
                }
            </div>
        </div>
    )
}
